import React, { useState, useEffect } from 'react';
import { Sun, Sunrise, Moon } from 'lucide-react';
import { cn } from '../lib/utils';

const DynamicGreeting = ({ isMobile = false }) => {
    const [greeting, setGreeting] = useState('');
    const [icon, setIcon] = useState(null);
    const [username, setUsername] = useState('User');

    useEffect(() => {
        const updateGreeting = () => {
            const hour = new Date().getHours();
            const iconSize = isMobile ? "h-5 w-5" : "h-8 w-8";
            
            if (hour >= 5 && hour < 12) {
                setGreeting('Good Morning');
                setIcon(<Sun className={`${iconSize} text-[#FF7D00]`} />);
            } else if (hour >= 12 && hour < 17) {
                setGreeting('Good Afternoon');
                setIcon(<Sunrise className={`${iconSize} text-[#FF7D00]`} />);
            } else if (hour >= 17 && hour < 21) {
                setGreeting('Good Evening');
                setIcon(<Moon className={`${iconSize} text-[#FF7D00]`} />);
            } else {
                setGreeting('Good Night');
                setIcon(<Moon className={`${iconSize} text-[#FF7D00]`} />);
            }
        };

        updateGreeting();
        const interval = setInterval(updateGreeting, 60000);
        
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                if (user.firstName && user.lastName) {
                    setUsername(`${user.firstName} ${user.lastName}`);
                } else if (user.firstName) {
                    setUsername(user.firstName);
                } else if (user.username) {
                    setUsername(user.username);
                }
            } catch (e) {
                console.error("Error parsing user context:", e);
                setUsername('Member');
            }
        }
        return () => clearInterval(interval);
    }, [isMobile]);

    return (
        <div className={cn("animate-in fade-in slide-in-from-left-4 duration-1000 ease-out", isMobile ? "py-0" : "py-2")}>
            <div className={`flex items-center ${isMobile ? 'gap-2' : 'gap-4'}`}>
                {/* Time-Based Icon */}
                <div className={`${isMobile ? 'p-1.5' : 'p-3'} bg-white dark:bg-slate-800 rounded-lg sm:rounded-3xl shadow-xl shadow-black/5 border border-slate-100 dark:border-slate-700 shrink-0`}>
                    {icon}
                </div>
                
                <div className="space-y-0 min-w-0 flex-1">
                    <h1 className={`${isMobile ? 'text-[10.5px] font-bold leading-none' : 'text-2xl sm:text-3xl font-black'} tracking-tight text-slate-800 dark:text-slate-100`}>
                        Hi, {isMobile ? username.split(' ')[0] : <span className="text-[#FF7D00]">{username}</span>}, {greeting}!
                    </h1>
                    {!isMobile && (
                        <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500 flex items-center gap-2">
                            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                            System Online: <span className="text-emerald-600 dark:text-emerald-400">Stable</span>
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DynamicGreeting;
